/**
 * Facet WP plugin scripts
 */

import $ from 'jquery'
import Jump from 'jump.js'
import { easeOutQuad } from 'ez.js'
import { lazyLoadObserve } from './lazyLoad'

const facetToggleBtns = document.querySelectorAll('.js-toggle-facet-filters');
const fixedMobileContainer = document.querySelector('.js-fixed-filters-btn');

window.addEventListener('load', () => {
  if(facetToggleBtns.length) {
    facetToggleBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        document.body.classList.toggle('filters-opened');
      });
    });
  }

  if(fixedMobileContainer) {
    let windowWidth = window.innerWidth;

    const fixedMobileBtnObsCallback = (entries) => {
      entries.forEach((entry) => {
        // console.log(entry.boundingClientRect.top)
        // console.log(entry.isIntersecting)
        // console.log(fixedMobileBtn.offsetHeight)
        if (entry.boundingClientRect.top <= 78 && !entry.isIntersecting && fixedMobileContainer.querySelector('.search-filters__btn').offsetHeight !== 0) {
          entry.target.classList.add('sticky');
        } else {
          entry.target.classList.remove('sticky');
        }
      })
    }

    const fixedMobileBtnObs = new IntersectionObserver(fixedMobileBtnObsCallback, {
      rootMargin: `-78px 0px 0px 0px`,
      threshold: 1,
    });

    if (windowWidth < 768) {
      fixedMobileBtnObs.observe(fixedMobileContainer);
    }
  }

  if (typeof FWP === 'object') {
    const loaders = Array.from(document.getElementsByClassName('js-loader'))
    const itemsList = document.querySelector('.facetwp-template')

    let fwpPager = Array.from(document.getElementsByClassName('facetwp-page'));
    let hasRefreshed = false;
    if (fwpPager) {
      fwpPager.forEach((pager) => {
        pager.addEventListener('click', (e) => {
          hasRefreshed = true;

          Jump('.main', {
            duration: 700,
            easing: easeOutQuad,
          })
        })
      })
    }

    $(document).on('facetwp-loaded', () => {
      const defaultObserver = lazyLoadObserve()
      defaultObserver.observe()

      fwpPager = Array.from(document.getElementsByClassName('facetwp-page'));
      hasRefreshed = false;

      if (fwpPager) {
        fwpPager.forEach((pager) => {
          pager.addEventListener('click', (e) => {
            hasRefreshed = true;

            Jump('.main', {
              duration: 700,
              easing: easeOutQuad,
            })
          })
        })
      }

      if (hasRefreshed) {
        Jump('.main', {
          duration: 700,
          easing: easeOutQuad,
          callback: () => { hasRefreshed = false }
        })
      }

      if (loaders.length) {
        loaders.forEach((loader) => {
          loader.classList.remove('is-loading')
        })
      }

      itemsList.classList.remove('is-loading')
    })

    $(document).on('facetwp-refresh', () => {
      if (loaders.length) {
        loaders.forEach((loader) => {
          loader.classList.add('is-loading')
        })
      }

      itemsList.classList.add('is-loading')
    })
  }
})
